export default BulkCampaignStat;

interface BulkCampaignStatProps {
  label: string;
  data: string | number;
}

function BulkCampaignStat(props: BulkCampaignStatProps) {
  const { label, data } = props;

  // Old layout: right-aligned column with the label always visible above the value. Replaced below
  // with the centered layout (label shown as a native title tooltip instead) to match the new
  // stat-tile grid design ported from Frontend (bulk-campaign-report-ui-port, Task 3).
  // return (
  //   <div className="flex flex-col items-end gap-y-2">
  //     <p className="text-xs">{label}</p>
  //     <p className="text-lg">{data}</p>
  //   </div>
  // );

  return (
    <div
      className="flex items-center justify-center"
      title={label}
    >
      <p className="text-lg">{data}</p>
    </div>
  );
}
